import { Injectable } from '@angular/core';
import { Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { AwsHttp } from '../aws/http';
import { ErrorHandler } from '../restapi/error-handler';
import { UserService } from '../user/user.service';
import { ObservableUtils } from '../util/observable-utils';
import { BillingInfo, InvoiceInfo } from './billing';

class BillingQuery {
    end_year: string;
    end_month: string;
    billingCycles: number
}

@Injectable()
export class BillingService {
    constructor(
        private http: AwsHttp,
        private errorHandler: ErrorHandler,
        private observableUtils: ObservableUtils,
        private userService: UserService
    ) { }

    private get baseUrl() {
        return `${this.userService.getApiUrl()}/billing`;
    }

    private get query(): BillingQuery {
        const date = new Date();
        return {
            end_year: date.getFullYear().toString(),
            end_month: (date.getMonth() + 1).toString(),
            billingCycles: 12
        };
    }

    private get headers() {
        return new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });
    }

    private getStats(query: BillingQuery): Observable<BillingInfo> {
        return this.http
            .post(`${this.baseUrl}/stats`, JSON.stringify(query), { headers: this.headers })
            .map((response: Response) => new BillingInfo(response.json()))
            .catch((response: Response) => this.errorHandler.throwError(response));
    }

    private getCost(query: BillingQuery): Observable<InvoiceInfo[]> {
        return this.observableUtils.retry(
            () => this.http
                .post(`${this.baseUrl}/cost`, JSON.stringify(query), { headers: this.headers })
                .map((response: Response) => response.json())
                .catch((response: Response) => this.errorHandler.throwError(response)),
            3
        );
    }

    private padStart(s: string, length: number, padding: string) {
        while (s.length < length) {
            s = padding + s;
        }
        return s;
    }

    getCycles() {
        const query = this.query;
        return Observable.forkJoin(
            this.getStats(query),
            this.getCost(query)
        ).map(([cycles, invoices]) => {
            invoices.forEach(invoice => {
                let [year, month, day] = invoice.creationDate.split('-');
                let billingYear = Number(year);
                let billingMonth = Number(month);

                // if the bill month is january
                // then go back to december and decrement the year
                /*if (billingMonth === 0) {
                    billingYear -= 1;
                    billingMonth = 12;
                }*/
                invoice.invoiceForDate = `${this.padStart(billingYear.toString(), 2, '0')}-${this.padStart(billingMonth.toString(), 2, '0')}-${day}`
            });

            cycles.updateCyclesWithCostInfo(invoices);
            cycles.orderDescending();
            cycles.removePast2MonthsSansInvoice();
            return cycles;
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/billing/billing.service.ts